import * as React from "react";
import { useTheme } from "@mui/material/styles";
import Autocomplete from "@mui/material/Autocomplete";
import TextField from "@mui/material/TextField";
import Button from "@mui/material/Button";
import Paper from "@mui/material/Paper";
import Popper from "@mui/material/Popper";
import ButtonGroup from "@mui/material/ButtonGroup";
import { useLanguage } from "../Components/Localization/LanguageContext";
import strings from "../Components/Localization/strings";

export default function MultipleSelect(props, { width = 120 }) {
  const { language } = useLanguage();
  const pageTitle = "DropdownSearch";
  const theme = useTheme();
  const [itemName, setItemName] = React.useState([]);
  const items = props.items;
  const id = props.id;
  const [selectAll, setSelectAll] = React.useState(false);
  const [isUpdating, setIsUpdating] = React.useState(false);
  const triggerSearch = props.triggerSearch;
  let searchCriteria = props.label;

  switch (searchCriteria) {
    case "Activity Type":
      searchCriteria = "processTypeIds";
      break;
    case "Services":
      searchCriteria = "serviceIds";
      break;
    case "Forms":
      searchCriteria = "formIds";
      break;
    case "Users":
      searchCriteria = "userIds";
      break;
    case "Billable":
      searchCriteria = "isBillable";
      break;
    case "Teams":
      searchCriteria = "teamIds";
      break;
    case "Finalized":
      searchCriteria = "isFinalized";
      break;
    default:
      break;
  }

  const handleChange = (event, value) => {
    setIsUpdating(true);

    let placeholder =
      searchCriteria === "userIds"
        ? value.map((item) => item.username)
        : value.map((item) => item.name);
    setItemName(placeholder);
    setSelectAll(placeholder.length === items.length);
    placeholder = placeholder.map((name) => name.replace(/,/g, ""));

    console.log("here: ", placeholder);

    setIsUpdating(false);
    triggerSearch(searchCriteria + ":" + placeholder);
  };

  const handleSelectAll = () => {
    const arrayOfNames = items.map((obj) => obj.name);
    setItemName(arrayOfNames);
    setSelectAll(true);
    triggerSearch(searchCriteria + ":" + []);
  };

  const handleSelectNone = () => {
    setItemName([]);
    setSelectAll(false);
    triggerSearch(searchCriteria + ":" + []);
  };

  const MyPopper = function (props) {
    const addAllClick = (e) => {
      e.preventDefault(); // Prevent the default behavior (closing the Popper)
      e.stopPropagation(); // Stop the click event from reaching the Autocomplete
      console.log("Add All");
      handleSelectAll();
    };

    const clearClick = (e) => {
      e.preventDefault(); // Prevent the default behavior (closing the Popper)
      e.stopPropagation(); // Stop the click event from reaching the Autocomplete
      console.log("Clear");
      handleSelectNone();
    };

    return (
      <Popper {...props}>
        <div
          style={{
            padding: theme.spacing(1),
            display: "flex",
            justifyContent: "center",
            alignItems: "center",
          }}
        >
          <Paper
            style={{
              backgroundColor: theme.palette.background.paper,
              opacity: 1,
            }}
            elevation={3}
          >
            <ButtonGroup
              color="primary"
              aria-label="outlined primary button group"
              style={{
                display: "flex",
                justifyContent: "center",
                alignItems: "center",
                width: "100%",
              }}
            >
              <Button color="primary" onMouseDown={addAllClick}>
                {strings[pageTitle][language].all}
              </Button>
              <Button color="primary" onMouseDown={clearClick}>
                {strings[pageTitle][language].clear}
              </Button>
            </ButtonGroup>
            {props.children}
          </Paper>
        </div>
      </Popper>
    );
  };

  return isUpdating ? (
    ""
  ) : (
    <div style={{ width: 200 }}>
      <Autocomplete
        PaperComponent={(props) => (
          <Paper
            {...props}
            style={{
              maxHeight: 400,
              overflowY: "auto",
              maxWidth: 300,
              overflow: "hidden",
            }}
          />
        )}
        PopperComponent={MyPopper}
        disableCloseOnSelect
        multiple
        id={id}
        options={items ? items : []}
        size="small"
        value={
          searchCriteria === "userIds"
            ? items?.filter((item) => itemName.includes(item.username))
            : items?.filter((item) => itemName.includes(item.name))
        }
        getOptionLabel={
          searchCriteria === "userIds"
            ? (option) => option.username
            : (option) => option.name
        }
        onChange={handleChange}
        renderTags={(value, getTagProps) =>
          value?.length <= 1 ? (
            value.map((option, index) => (
              <span key={index} {...getTagProps(index)}>
                {option.name}
              </span>
            ))
          ) : (
            <span>
              {value?.length} {strings[pageTitle][language].itemsSelected}
            </span>
          )
        }
        renderInput={(params) => (
          <TextField
            {...params}
            label={props.labelText}
            variant="outlined"
            InputLabelProps={{ shrink: true }}
            size="small"
          />
        )}
      />
    </div>
  );
}
